// @flow

import _ from 'lodash';
import React, { Component, Children, type Node } from 'react';
import CookieBanner from 'client/components/banner/CookieBanner';
import HtmlHead from 'client/components/htmlHead';
import NpnFooter from 'client/components/npnFooter';
import { fetchMembers } from 'client/actions/members';
import { fetchUser } from 'client/actions/user';
import { fetchContentful } from 'client/actions/contentful';
import { fetchConfiguration } from 'client/actions/enterprise/user';
import StrideHeaderWrapper from 'client/components/strideHeaderWrapper';
import 'client/styles/common.scss';

type Props = {
  children: Node,
};

const CONTENTFUL_ENTRY_ID = '2DqRfoCXuXzlmF0LvVaSRJ';

class App extends Component<Props> {
  static fetchData({ dispatch }: { dispatch: Function }) {
    return Promise.all([
      dispatch(fetchConfiguration()),
      dispatch(fetchUser()),
      dispatch(fetchMembers()),
    ]).then((response) => {
      // TODO: locale is for contentful Spanish translation support
      // It comes from user object from 'fetchUser'.
      // We toggle this 'locale' when user change their language preference in user setting (not browser language setup)
      // And it default to 'en-US' if user do not login.
      const locale = _.get(response, '[1].locale', 'en-US');
      return dispatch(fetchContentful(CONTENTFUL_ENTRY_ID, locale));
    });
  }

  render() {
    return (
      <StrideHeaderWrapper showPhone={false} noShadow>
        <React.Fragment>
          <HtmlHead title="Stride Health - Get Prescriptions" description="" />
          {Children.only(this.props.children)}
          <CookieBanner />
          <NpnFooter showPhone={false} />
        </React.Fragment>
      </StrideHeaderWrapper>
    );
  }
}

export default App;
